export enum CountryEnum {
    Italy = 'it',
    Spain = 'es',
    Germany = 'de',
    Brasil = 'br',
    Argentina = 'ar',
};

export const CountryName: { [key in CountryEnum]: string } = {
    'it': "Italia",
    'es': "España",
    'de': "Deutschland",
    'br': "Brasil",
    'ar': "Argentina",
};

export const countries = Object.values(CountryEnum).sort();

export const isCountryValid = (country: string | undefined) => {
    return country !== undefined && Object.values(CountryEnum).includes(country as CountryEnum);
}

export const getSupportLinkByCountryCode = (country: CountryEnum) => {
    switch (country) {
        case CountryEnum.Italy:
            return process.env.REACT_APP_SupportPageLink_IT ?? "";
        case CountryEnum.Spain:
            return process.env.REACT_APP_SupportPageLink_ES ?? "";
        case CountryEnum.Germany:
            return process.env.REACT_APP_SupportPageLink_DE ?? "";
        case CountryEnum.Argentina:
            return process.env.REACT_APP_SupportPageLink_AR ?? "";
        case CountryEnum.Brasil:
            return process.env.REACT_APP_SupportPageLink_BR ?? "";
        default:
            return "";
    }
}

export const getServiceMailByCountryCode = (country: CountryEnum) => {
    switch (country) {
        case CountryEnum.Italy:
            return process.env.REACT_APP_ServiceMail_IT ?? "";
        case CountryEnum.Spain:
            return process.env.REACT_APP_ServiceMail_ES ?? "";
        case CountryEnum.Germany:
            return process.env.REACT_APP_ServiceMail_DE ?? "";
        case CountryEnum.Argentina:
            return process.env.REACT_APP_ServiceMail_AR ?? "";
        case CountryEnum.Brasil:
            return process.env.REACT_APP_ServiceMail_BR ?? "";
        default:
            return "";
    }
}

export const getServicePhoneByCountryCode = (country: CountryEnum) => {
    switch (country) {
        case CountryEnum.Italy:
            return process.env.REACT_APP_ServicePhone_IT ?? "";
        case CountryEnum.Spain:
            return process.env.REACT_APP_ServicePhone_ES ?? "";
        case CountryEnum.Germany:
            return process.env.REACT_APP_ServicePhone_DE ?? "";   
        case CountryEnum.Argentina:
            return process.env.REACT_APP_ServicePhone_AR ?? ""; 
        case CountryEnum.Brasil:
            return process.env.REACT_APP_ServicePhone_BR ?? ""; 
        default:
            return "";
    }
}

export const getInfoPointPhoneByCountryCode = (country: CountryEnum) => {
    switch (country) {
        case CountryEnum.Italy:
            return process.env.REACT_APP_InfoPoint_Phone_IT ?? "";
        case CountryEnum.Spain:
            return process.env.REACT_APP_InfoPoint_Phone_ES ?? "";
        case CountryEnum.Germany:
            return process.env.REACT_APP_InfoPoint_Phone_DE ?? "";
        case CountryEnum.Argentina:
            return process.env.REACT_APP_InfoPoint_Phone_AR ?? "";
        case CountryEnum.Brasil:
            return process.env.REACT_APP_InfoPoint_Phone_BR ?? "";
        default:
            return "";
    }
}

export const getGDPRFileByCountryCode = (country: CountryEnum) => {
    switch (country) {
        case CountryEnum.Italy:
            return process.env.REACT_APP_GDPR_File_IT ?? "";
        case CountryEnum.Spain:
            return process.env.REACT_APP_GDPR_File_ES ?? "";
        case CountryEnum.Germany:
            return process.env.REACT_APP_GDPR_File_DE ?? "";
        case CountryEnum.Argentina:
            return process.env.REACT_APP_GDPR_File_AR ?? "";
        case CountryEnum.Brasil:
            return process.env.REACT_APP_GDPR_File_BR ?? "";
        default:
            return "";
    }
}